import de from "./de";
import en from "./en";
import es from "./es";
import fr from "./fr";
import it from "./it";
import ja from "./ja";
import pt from "./pt";
import zh from "./zh";
import pl from "./pl";

const Localize = {
    en_AU: { ...en },
    en_CA: { ...en },
    en_GB: { ...en },
    en_US: { ...en },
    es_ES: { ...es },
    es_MX: { ...es },
    es_AR: { ...es },
    pt_PT: { ...pt },
    pt_BR: { ...pt },
    fr_FR: { ...fr },
    fr_CA: { ...fr },
    de_DE: { ...de },
    it_IT: { ...it },
    zh_CN: { ...zh },
    ja_JP: { ...ja },
    pl_PL: { ...pl },
};

export default Localize;
